module.exports = __webpack_public_path__ + "static/media/trainVideo11.03a34e52.mp4";